module.exports = new __parcel__URL__("moon-safari.34421d9f.jpg").toString();